import React from 'react';
import { Link } from 'react-router-dom';
import { Stethoscope } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { visitCockpitPath } from '@/lib/portalRoutes';

interface EncounterChipProps {
  encounterId?: string | null;
  /** Optional label override (e.g. "Visit · 04/12/2026"). */
  label?: string;
  className?: string;
}

/**
 * Small clickable chip that links a chart artifact (note, prescription,
 * lab order, diagnosis, etc.) back to the visit cockpit it belongs to.
 *
 * Renders nothing if `encounterId` is missing.
 */
const EncounterChip: React.FC<EncounterChipProps> = ({
  encounterId, label, className,
}) => {
  if (!encounterId) return null;
  return (
    <Link
      to={visitCockpitPath(encounterId)}
      className={`inline-flex ${className || ''}`}
      onClick={e => e.stopPropagation()}
      title='Open the visit cockpit for this encounter'
    >
      <Badge
        variant='outline'
        className='gap-1 border-brand-teal/30 bg-brand-teal/5 text-brand-teal hover:bg-brand-teal/10'
      >
        <Stethoscope className='h-3 w-3' />
        {label || 'Visit'}
      </Badge>
    </Link>
  );
};

export default EncounterChip;
